import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum ActivityRegistrationFields {
    PARENT_DATA = 'parentData',
    STUDENT_DATA = 'studentData',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ActivityRegistrationFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<ActivityRegistrationFields, Data> = {
        [ActivityRegistrationFields.PARENT_DATA]: {
            text: 'Elterndaten',
        },
        [ActivityRegistrationFields.STUDENT_DATA]: {
            text: 'Schülerdaten',
        },
        [ActivityRegistrationFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readOnly: true,
        },
        [ActivityRegistrationFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readOnly: true,
        },
    }

    export const Items = mapRecordToItems(Record);
}
